/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-duplicate-props */
import React from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Grid,
  Box,
  IconButton,
  Typography,
  ButtonBase,
  Chip,
  FormHelperText,
  Paper,
  LinearProgress,
  Tabs,
  Tab,
  Checkbox,
  ListItemText,
  Tooltip,
  CircularProgress,
  Collapse,
} from "@material-ui/core"
import {
  PhotoCamera,
  Face,
  Lock,
  VisibilityOff,
  Visibility,
  CreditCard,
  FiberPin,
  CropFree,
  Add,
  LockOutlined,
  Delete,
  ExpandMore,
  ExpandLess,
} from "@material-ui/icons"
import { Alert, Autocomplete } from "@material-ui/lab"
import OptimizedUserAutocomplete from "src/components/Common/OptimizedUserAutocomplete"
import {
  getPanelBoxStyle,
  getPinPanelStyle,
  getPanelIconColor,
  getPinIconColor,
  getPanelCaptionColor,
  getPinCaptionColor,
  getPinInputStyle,
  secondaryIconBtnStyle,
  smallActionBtnStyle,
  getFloorChipStyle,
  previewImageStyle,
  imagePlaceholderStyle,
  compressionPaperStyle,
  cameraButtonStyle,
  tabStyle,
  dialogActionsStyle,
  submitBtnStyle,
} from "./NewAndEditRostro.styles"

const LockedTab = ({ label, icon }) => (
  <Tooltip
    title={
      <Box style={{ textAlign: "center", padding: "2px 0" }}>
        <Typography
          variant="caption"
          style={{ display: "block", fontWeight: 700 }}
        >
          Módulo no activado
        </Typography>
        <Typography
          variant="caption"
          style={{ display: "block", color: "#ffcc80" }}
        >
          Requiere activación
        </Typography>
      </Box>
    }
    arrow
    placement="top"
  >
    <span style={{ cursor: "not-allowed" }}>
      <Tab
        disabled
        label={
          <Box
            display="flex"
            alignItems="center"
            style={{ gap: 4, opacity: 0.4 }}
          >
            {icon}
            <span>{label}</span>
            <LockOutlined style={{ fontSize: 12, color: "#9e9e9e" }} />
          </Box>
        }
        style={{ ...tabStyle, pointerEvents: "none" }}
      />
    </span>
  </Tooltip>
)

// ── Reusable credential panel (TAGs & QRs) ──────────────────────────────────
const CredentialPanel = ({
  tipo,
  tarjetas,
  setTarjetas,
  accentColor,
  chipStyle,
  borderColor,
  icon,
  label,
  chipLabel,
  placeholderCodigo,
  placeholderBulk,
  placeholderLabel,
}) => {
  const [singleInput, setSingleInput] = React.useState("")
  const [singleLabel, setSingleLabel] = React.useState("")
  const [showBulk, setShowBulk] = React.useState(false)
  const [bulkInput, setBulkInput] = React.useState("")

  const items = tarjetas.filter(t => t.tipo === tipo)

  const addSingle = () => {
    const codigo = singleInput.trim()
    if (!codigo) return
    setTarjetas([...tarjetas, { tipo, codigo, label: singleLabel.trim() }])
    setSingleInput("")
    setSingleLabel("")
  }

  const addBulk = () => {
    const nuevas = bulkInput
      .split(",")
      .map(c => c.trim())
      .filter(c => c.length > 0)
      .map(codigo => ({ tipo, codigo, label: "" }))
    if (nuevas.length > 0) setTarjetas([...tarjetas, ...nuevas])
    setBulkInput("")
  }

  const updateTarjeta = (globalIndex, field, value) =>
    setTarjetas(
      tarjetas.map((t, i) => (i === globalIndex ? { ...t, [field]: value } : t))
    )

  const removeTarjeta = globalIndex =>
    setTarjetas(tarjetas.filter((_, i) => i !== globalIndex))

  return (
    <Box style={getPanelBoxStyle(items.length > 0)}>
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={1.5}
      >
        <Box display="flex" alignItems="center" style={{ gap: 8 }}>
          {React.cloneElement(icon, {
            style: { fontSize: 24, color: getPanelIconColor(items.length > 0) },
          })}
          <Box>
            <Typography
              variant="body2"
              style={{ fontWeight: 600, lineHeight: 1.3 }}
            >
              {label}
              <Chip
                size="small"
                label={chipLabel}
                style={{
                  marginLeft: 6,
                  fontSize: "0.65rem",
                  height: 18,
                  ...chipStyle,
                }}
              />
            </Typography>
            <Typography
              variant="caption"
              style={{ color: getPanelCaptionColor(items.length > 0) }}
            >
              {items.length > 0
                ? `✓ ${items.length} código(s) registrado(s)`
                : "Opcional — ingrese o escanee el código"}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Existing items */}
      {items.length > 0 && (
        <Box
          display="flex"
          flexDirection="column"
          style={{ gap: 8, marginBottom: 12 }}
        >
          {tarjetas.map((t, i) =>
            t.tipo !== tipo ? null : (
              <Box
                key={i}
                style={{
                  border: `1px solid ${borderColor}`,
                  borderRadius: 6,
                  padding: "6px 8px",
                  backgroundColor: "white",
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  style={{ gap: 8, marginBottom: 4 }}
                >
                  <TextField
                    size="small"
                    fullWidth
                    placeholder={`${placeholderCodigo} ${items.indexOf(t) + 1}`}
                    value={t.codigo}
                    onChange={e => updateTarjeta(i, "codigo", e.target.value)}
                    variant="outlined"
                    inputProps={{
                      style: {
                        fontWeight: 600,
                        fontSize: "0.85rem",
                        letterSpacing: "0.05em",
                      },
                    }}
                    style={{ backgroundColor: "white" }}
                  />
                  <Tooltip title="Eliminar">
                    <IconButton
                      size="small"
                      onClick={() => removeTarjeta(i)}
                      style={{ padding: 4 }}
                    >
                      <Delete style={{ fontSize: 16, color: "#f44336" }} />
                    </IconButton>
                  </Tooltip>
                </Box>
                <TextField
                  size="small"
                  fullWidth
                  placeholder={placeholderLabel}
                  value={t.label}
                  onChange={e => updateTarjeta(i, "label", e.target.value)}
                  variant="standard"
                  inputProps={{ style: { fontSize: "0.75rem" } }}
                />
              </Box>
            )
          )}
        </Box>
      )}

      {/* Single add row */}
      <Box display="flex" alignItems="flex-start" style={{ gap: 8 }}>
        <Box flex={1} display="flex" flexDirection="column" style={{ gap: 4 }}>
          <TextField
            size="small"
            fullWidth
            placeholder={`Código ${tipo.toUpperCase()}`}
            value={singleInput}
            onChange={e => setSingleInput(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter") {
                e.preventDefault()
                addSingle()
              }
            }}
            variant="outlined"
            style={{ backgroundColor: "white", borderRadius: 6 }}
            inputProps={{ style: { fontSize: "0.85rem" } }}
          />
          <TextField
            size="small"
            fullWidth
            placeholder={placeholderLabel}
            value={singleLabel}
            onChange={e => setSingleLabel(e.target.value)}
            onKeyDown={e => {
              if (e.key === "Enter") {
                e.preventDefault()
                addSingle()
              }
            }}
            variant="standard"
            inputProps={{ style: { fontSize: "0.75rem" } }}
          />
        </Box>
        <Tooltip title={`Agregar ${tipo.toUpperCase()}`}>
          <span>
            <IconButton
              size="small"
              onClick={addSingle}
              disabled={!singleInput.trim()}
              style={{
                padding: 6,
                marginTop: 2,
                backgroundColor: singleInput.trim() ? accentColor : "#f5f5f5",
                color: singleInput.trim() ? "white" : "#bdbdbd",
                borderRadius: 6,
              }}
            >
              <Add style={{ fontSize: 20 }} />
            </IconButton>
          </span>
        </Tooltip>
      </Box>

      {/* Bulk toggle */}
      <Box mt={1}>
        <Button
          size="small"
          onClick={() => setShowBulk(v => !v)}
          endIcon={
            showBulk ? (
              <ExpandLess style={{ fontSize: 14 }} />
            ) : (
              <ExpandMore style={{ fontSize: 14 }} />
            )
          }
          style={{
            textTransform: "none",
            fontSize: "0.72rem",
            color: "#9e9e9e",
            padding: "2px 6px",
          }}
        >
          Agregar varios a la vez
        </Button>

        <Collapse in={showBulk}>
          <Box mt={0.5} display="flex" alignItems="center" style={{ gap: 8 }}>
            <TextField
              size="small"
              fullWidth
              placeholder={placeholderBulk}
              value={bulkInput}
              onChange={e => setBulkInput(e.target.value)}
              onKeyDown={e => {
                if (e.key === "Enter" && bulkInput.trim()) {
                  e.preventDefault()
                  addBulk()
                }
              }}
              variant="outlined"
              style={{ backgroundColor: "white", borderRadius: 6 }}
              inputProps={{ style: { fontSize: "0.8rem" } }}
              InputProps={{
                endAdornment: bulkInput.trim() ? (
                  <Tooltip title="Agregar todos (o presione Enter)">
                    <IconButton
                      size="small"
                      onClick={addBulk}
                      style={{ padding: 3 }}
                    >
                      <Add style={{ fontSize: 16, color: accentColor }} />
                    </IconButton>
                  </Tooltip>
                ) : null,
              }}
            />
          </Box>
          <Typography
            variant="caption"
            style={{ color: "#9e9e9e", marginTop: 4, display: "block" }}
          >
            Separe múltiples códigos con coma y presione Enter o el botón
          </Typography>
        </Collapse>
      </Box>
    </Box>
  )
}

// ── Main dialog ──────────────────────────────────────────────────────────────
const NewAndEditRostroDialog = ({
  open,
  onClose,
  isEditing,
  loading,
  activeTab,
  setActiveTab,
  formData,
  setFormData,
  handleInputChange,
  getHelperText,
  getButtonText,
  handleSubmit,
  imagePreview,
  imageChanged,
  imageCompressing,
  compressionInfo,
  fileInputRef,
  handleImageClick,
  handleImageChange,
  FLOOR_OPTIONS,
  ALL_FLOORS_VALUE,
  getFloorLabel,
  handlePisosChange,
  biometricDevices,
  usersByUnit,
  optionsById,
  pinError,
  setPinError,
  showPin,
  setShowPin,
  handlePinChange,
  tarjetas,
  setTarjetas,
  moduloBiometricosResidentes,
}) => {
  const pinLength = formData.pin?.length ?? 0

  const tags = tarjetas.filter(t => t.tipo === "tag")
  const qrs = tarjetas.filter(t => t.tipo === "qr")

  React.useEffect(() => {
    if (!moduloBiometricosResidentes && activeTab > 0) {
      setActiveTab(0)
    }
  }, [moduloBiometricosResidentes, activeTab, setActiveTab])

  const handleTabChange = (_, newValue) => {
    if (!moduloBiometricosResidentes && newValue > 0) return
    setActiveTab(newValue)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{isEditing ? "Editar Rostro" : "Nuevo Rostro"}</DialogTitle>

      <DialogContent style={{ padding: "16px 24px" }}>
        <Box style={{ borderBottom: "1px solid #e0e0e0", marginBottom: 16 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
          >
            <Tab
              label="Información General"
              icon={<Face style={{ fontSize: 18 }} />}
              style={tabStyle}
            />

            {moduloBiometricosResidentes ? (
              <Tab
                label={
                  <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                    <Lock style={{ fontSize: 16 }} />
                    <span>PIN</span>
                    {pinLength >= 4 && (
                      <Chip
                        size="small"
                        label="✓"
                        style={{
                          height: 16,
                          fontSize: "0.6rem",
                          backgroundColor: "#e8f5e9",
                          color: "#2e7d32",
                        }}
                      />
                    )}
                  </Box>
                }
                style={tabStyle}
              />
            ) : (
              <LockedTab label="PIN" icon={<Lock style={{ fontSize: 16 }} />} />
            )}

            {moduloBiometricosResidentes ? (
              <Tab
                label={
                  <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                    <CreditCard style={{ fontSize: 16 }} />
                    <span>TAGs</span>
                    {tags.length > 0 && (
                      <Chip
                        size="small"
                        label={tags.length}
                        style={{
                          height: 16,
                          fontSize: "0.6rem",
                          backgroundColor: "#e3f2fd",
                          color: "#1976d2",
                        }}
                      />
                    )}
                  </Box>
                }
                style={tabStyle}
              />
            ) : (
              <LockedTab
                label="TAGs"
                icon={<CreditCard style={{ fontSize: 16 }} />}
              />
            )}

            {moduloBiometricosResidentes ? (
              <Tab
                label={
                  <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                    <CropFree style={{ fontSize: 16 }} />
                    <span>QRs</span>
                    {qrs.length > 0 && (
                      <Chip
                        size="small"
                        label={qrs.length}
                        style={{
                          height: 16,
                          fontSize: "0.6rem",
                          backgroundColor: "#f3e5f5",
                          color: "#7b1fa2",
                        }}
                      />
                    )}
                  </Box>
                }
                style={tabStyle}
              />
            ) : (
              <LockedTab
                label="QRs"
                icon={<CropFree style={{ fontSize: 16 }} />}
              />
            )}
          </Tabs>
        </Box>

        {/* ══ TAB 0 — Información General ══ */}
        {activeTab === 0 && (
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box display="flex" flexDirection="column" alignItems="center">
                <Typography variant="subtitle2" gutterBottom>
                  Foto del Rostro
                  {isEditing && imageChanged && (
                    <Chip
                      size="small"
                      label="Nueva imagen"
                      color="primary"
                      style={{ marginLeft: 8 }}
                    />
                  )}
                </Typography>
                <Box position="relative">
                  {imagePreview ? (
                    <ButtonBase
                      onClick={handleImageClick}
                      disabled={imageCompressing}
                      style={{
                        borderRadius: 8,
                        overflow: "hidden",
                        opacity: imageCompressing ? 0.7 : 1,
                      }}
                      focusRipple
                    >
                      <img
                        key={imagePreview}
                        src={imagePreview}
                        alt="Foto del rostro"
                        style={previewImageStyle}
                      />
                      {imageCompressing && (
                        <Box
                          position="absolute"
                          top="50%"
                          left="50%"
                          style={{
                            transform: "translate(-50%,-50%)",
                            backgroundColor: "rgba(255,255,255,0.8)",
                            borderRadius: "50%",
                            padding: 8,
                          }}
                        >
                          <LinearProgress />
                        </Box>
                      )}
                    </ButtonBase>
                  ) : (
                    <ButtonBase
                      onClick={handleImageClick}
                      disabled={imageCompressing}
                      style={{
                        ...imagePlaceholderStyle,
                        opacity: imageCompressing ? 0.7 : 1,
                      }}
                      focusRipple
                    >
                      <Box
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <Face style={{ fontSize: 60, color: "#ccc" }} />
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          style={{ marginTop: 8 }}
                        >
                          {imageCompressing
                            ? "Comprimiendo..."
                            : "Click para cargar imagen"}
                        </Typography>
                        {imageCompressing && (
                          <LinearProgress
                            style={{ width: "80%", marginTop: 8 }}
                          />
                        )}
                      </Box>
                    </ButtonBase>
                  )}
                  <IconButton
                    style={cameraButtonStyle}
                    onClick={e => {
                      e.stopPropagation()
                      handleImageClick()
                    }}
                    disabled={imageCompressing}
                    size="small"
                  >
                    <PhotoCamera />
                  </IconButton>
                </Box>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleImageChange}
                  accept="image/*"
                  style={{ display: "none" }}
                />
                <Typography
                  variant="caption"
                  color="textSecondary"
                  align="center"
                  style={{ marginTop: 8 }}
                >
                  {isEditing
                    ? "Click para cambiar imagen (opcional)"
                    : "Click para cargar imagen"}
                  <br />
                  {!isEditing && (
                    <span style={{ color: "#9e9e9e", fontSize: "0.7rem" }}>
                      Requerida solo si no agrega PIN, TAG o QR
                    </span>
                  )}
                  <br />
                  {imageCompressing
                    ? "Comprimiendo imagen..."
                    : "Se comprimirá automáticamente si es necesario"}
                </Typography>
                {compressionInfo && (
                  <Box mt={1}>
                    <Paper style={compressionPaperStyle}>
                      <Typography
                        variant="caption"
                        color="primary"
                        style={{ fontWeight: "bold" }}
                      >
                        📸 Imagen optimizada
                      </Typography>
                      <br />
                      <Typography variant="caption" color="textSecondary">
                        {compressionInfo.originalSize}KB →{" "}
                        {compressionInfo.compressedSize}KB (
                        {compressionInfo.compressionRatio}% reducción)
                      </Typography>
                      <br />
                      <Typography variant="caption" color="textSecondary">
                        Dimensiones: {compressionInfo.dimensions.width}×
                        {compressionInfo.dimensions.height}px
                      </Typography>
                    </Paper>
                  </Box>
                )}
              </Box>
            </Grid>

            <Grid item xs={12} md={8}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Nombres y Apellidos"
                    autoComplete="new-password"
                    value={formData.nombre}
                    onChange={handleInputChange("nombre")}
                    required
                    error={!formData.nombre.trim() && formData.nombre !== ""}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Cédula / Pasaporte"
                    value={formData.identificacion}
                    onChange={handleInputChange("identificacion")}
                    required
                    placeholder="Ingrese número de cédula o pasaporte"
                    error={
                      !formData.identificacion.trim() &&
                      formData.identificacion !== ""
                    }
                    helperText={getHelperText()}
                    disabled={isEditing}
                    InputProps={{
                      style: {
                        backgroundColor: isEditing ? "#f5f5f5" : "inherit",
                        color: isEditing ? "#757575" : "inherit",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth variant="standard">
                    <InputLabel>Pisos</InputLabel>
                    <Select
                      multiple
                      value={formData.pisos}
                      onChange={handlePisosChange}
                      renderValue={selected => {
                        const sorted = [...selected].sort((a, b) => a - b)
                        const display = sorted.slice(0, 3)
                        const rest = Math.max(0, sorted.length - 3)
                        return (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              alignItems: "center",
                            }}
                          >
                            {display.map(v => (
                              <Chip
                                key={v}
                                label={getFloorLabel(v)}
                                size="small"
                                style={getFloorChipStyle(v)}
                                onDelete={() =>
                                  setFormData({
                                    ...formData,
                                    pisos: formData.pisos.filter(p => p !== v),
                                  })
                                }
                              />
                            ))}
                            {rest > 0 && `+${rest}`}
                          </Box>
                        )
                      }}
                      MenuProps={{ PaperProps: { style: { maxHeight: 400 } } }}
                    >
                      <MenuItem disabled value="">
                        <em>Seleccione los pisos</em>
                      </MenuItem>
                      <MenuItem
                        value={ALL_FLOORS_VALUE}
                        style={{
                          backgroundColor: "#f5f5f5",
                          fontWeight: "bold",
                        }}
                      >
                        <Checkbox
                          checked={
                            formData.pisos.length === FLOOR_OPTIONS.length
                          }
                          indeterminate={
                            formData.pisos.length > 0 &&
                            formData.pisos.length < FLOOR_OPTIONS.length
                          }
                        />
                        <ListItemText
                          primary={
                            formData.pisos.length === FLOOR_OPTIONS.length
                              ? "Deseleccionar Todos"
                              : "Seleccionar Todos"
                          }
                          primaryTypographyProps={{
                            style: {
                              fontWeight: "bold",
                              color:
                                formData.pisos.length === FLOOR_OPTIONS.length
                                  ? "#d32f2f"
                                  : "#2e7d32",
                            },
                          }}
                        />
                      </MenuItem>
                      <MenuItem disabled>
                        <Typography variant="subtitle2" color="textSecondary">
                          SUBSUELOS
                        </Typography>
                      </MenuItem>
                      {FLOOR_OPTIONS.filter(o => o.value < 0).map(o => (
                        <MenuItem key={o.value} value={o.value}>
                          <Checkbox
                            checked={formData.pisos?.indexOf(o.value) > -1}
                          />
                          <ListItemText primary={o.label} />
                        </MenuItem>
                      ))}
                      <MenuItem disabled>
                        <Typography
                          variant="subtitle2"
                          color="textSecondary"
                          style={{ marginTop: 8 }}
                        >
                          PISOS
                        </Typography>
                      </MenuItem>
                      {FLOOR_OPTIONS.filter(o => o.value > 0).map(o => (
                        <MenuItem key={o.value} value={o.value}>
                          <Checkbox
                            checked={formData.pisos?.indexOf(o.value) > -1}
                          />
                          <ListItemText primary={o.label} />
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      {formData.pisos.length > 0
                        ? formData.pisos.length === FLOOR_OPTIONS.length
                          ? "Todos los pisos seleccionados"
                          : `${formData.pisos.length} piso(s) seleccionado(s)`
                        : "Seleccione los pisos de acceso"}
                    </FormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <OptimizedUserAutocomplete
                    options={usersByUnit}
                    optionsById={optionsById}
                    label="Unidad Habitacional"
                    value={formData.destino}
                    onChange={(_, nv) =>
                      handleInputChange("destino")({
                        target: { value: nv ? nv.id : "" },
                      })
                    }
                    noOptionsText="No se encontraron opciones"
                    clearText="Limpiar"
                    openText="Abrir"
                    closeText="Cerrar"
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Tipo</InputLabel>
                    <Select
                      value={formData.tipo}
                      onChange={handleInputChange("tipo")}
                    >
                      {[
                        "propietario",
                        "familiar",
                        "empleado",
                        "visitante",
                        "inquilino",
                        "arrendatario",
                      ].map(t => (
                        <MenuItem key={t} value={t}>
                          {t.charAt(0).toUpperCase() + t.slice(1)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Estado</InputLabel>
                    <Select
                      value={formData.estado}
                      onChange={handleInputChange("estado")}
                    >
                      <MenuItem value="activo">Activo</MenuItem>
                      <MenuItem value="bloqueado">Bloqueado</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Autocomplete
                    multiple
                    options={[
                      {
                        id: "select-all",
                        nombre: "Seleccionar Todos",
                        isSelectAll: true,
                      },
                      ...biometricDevices.filter(d => d.estado === "activo"),
                    ]}
                    getOptionLabel={o =>
                      o.isSelectAll
                        ? "Seleccionar Todos los Dispositivos"
                        : `${o.nombre} (${o.ubicacion})`
                    }
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Dispositivos Biométricos"
                        variant="standard"
                      />
                    )}
                    value={biometricDevices.filter(d =>
                      formData.dispositivos_biometricos.includes(d.id)
                    )}
                    onChange={(_, nv) => {
                      if (nv.some(o => o.isSelectAll)) {
                        const allIds = biometricDevices
                          .filter(d => d.estado === "activo")
                          .map(d => d.id)
                        setFormData({
                          ...formData,
                          dispositivos_biometricos:
                            formData.dispositivos_biometricos.length ===
                            allIds.length
                              ? []
                              : allIds,
                        })
                      } else {
                        setFormData({
                          ...formData,
                          dispositivos_biometricos: nv.map(d => d.id),
                        })
                      }
                    }}
                    renderOption={(option, { selected }) =>
                      option.isSelectAll ? (
                        <>
                          <Checkbox
                            checked={
                              biometricDevices.length > 0 &&
                              formData.dispositivos_biometricos.length ===
                                biometricDevices.length
                            }
                            indeterminate={
                              formData.dispositivos_biometricos.length > 0 &&
                              formData.dispositivos_biometricos.length <
                                biometricDevices.length
                            }
                          />
                          <Typography variant="body2" color="primary">
                            {formData.dispositivos_biometricos.length ===
                            biometricDevices.length
                              ? "Deseleccionar Todos"
                              : "Seleccionar Todos"}
                          </Typography>
                        </>
                      ) : (
                        <>
                          <Checkbox
                            color="primary"
                            checked={selected}
                            style={{ marginRight: 8 }}
                          />
                          <Box>
                            <Typography variant="body2">
                              {option.nombre}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {option.ubicacion}
                            </Typography>
                          </Box>
                        </>
                      )
                    }
                    getOptionSelected={(o, v) =>
                      o.isSelectAll ? false : o.id === v.id
                    }
                    disableCloseOnSelect
                    limitTags={3}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Observaciones"
                    value={formData.observaciones}
                    onChange={handleInputChange("observaciones")}
                    multiline
                    rows={3}
                    placeholder="Observaciones adicionales (opcional)"
                  />
                </Grid>
                <Alert severity="info" style={{ marginTop: 8 }}>
                  Los cambios se sincronizarán en los dispositivos biométricos
                  en aproximadamente 30 minutos.
                </Alert>
              </Grid>
            </Grid>
          </Grid>
        )}

        {/* ══ TAB 1 — PIN ══ */}
        {activeTab === 1 && (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8} md={6}>
              <Box style={getPinPanelStyle(pinError, pinLength)}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  style={{ gap: 8 }}
                >
                  <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                    <Lock
                      style={{
                        fontSize: 28,
                        color: getPinIconColor(pinError, pinLength),
                      }}
                    />
                    <Box>
                      <Typography
                        variant="body2"
                        style={{ fontWeight: 600, lineHeight: 1.3 }}
                      >
                        PIN de Acceso
                      </Typography>
                      <Typography
                        variant="caption"
                        style={{
                          color: getPinCaptionColor(pinError, pinLength),
                        }}
                      >
                        {pinError ||
                          (pinLength >= 4
                            ? `✓ PIN configurado (${pinLength} dígitos)`
                            : "Opcional — entre 4 y 8 dígitos numéricos")}
                      </Typography>
                    </Box>
                  </Box>
                  <Tooltip title="Generar PIN aleatorio de 4 dígitos">
                    <Button
                      size="small"
                      variant="outlined"
                      startIcon={<FiberPin style={{ fontSize: 16 }} />}
                      onClick={() => {
                        const newPin = String(
                          Math.floor(1000 + Math.random() * 9000)
                        )
                        setFormData({ ...formData, pin: newPin })
                        setPinError("")
                        setShowPin(true)
                      }}
                      style={smallActionBtnStyle}
                    >
                      Generar PIN
                    </Button>
                  </Tooltip>
                </Box>
                <Box
                  mt={1.5}
                  display="flex"
                  alignItems="center"
                  style={{ gap: 8 }}
                >
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Ingrese PIN (4-8 dígitos)"
                    value={formData.pin ?? ""}
                    onChange={handlePinChange}
                    type={showPin ? "text" : "password"}
                    autoComplete="new-password"
                    inputProps={{
                      maxLength: 8,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: getPinInputStyle(showPin),
                    }}
                    error={Boolean(pinError)}
                    variant="outlined"
                    style={{ backgroundColor: "white", borderRadius: 6 }}
                  />
                  <Tooltip title={showPin ? "Ocultar PIN" : "Mostrar PIN"}>
                    <IconButton
                      size="small"
                      onClick={() => setShowPin(!showPin)}
                      style={secondaryIconBtnStyle}
                    >
                      {showPin ? (
                        <VisibilityOff style={{ fontSize: 18 }} />
                      ) : (
                        <Visibility style={{ fontSize: 18 }} />
                      )}
                    </IconButton>
                  </Tooltip>
                  {pinLength > 0 && (
                    <Tooltip title="Limpiar PIN">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setFormData({ ...formData, pin: "" })
                          setPinError("")
                        }}
                        style={secondaryIconBtnStyle}
                      >
                        <Delete style={{ fontSize: 18, color: "#ef4444" }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </Box>
                {pinLength > 0 && (
                  <Box mt={0.5}>
                    <Typography
                      variant="caption"
                      style={{ color: pinLength < 4 ? "#ff9800" : "#4caf50" }}
                    >
                      {pinLength}/8 dígitos{pinLength < 4 && " — mínimo 4"}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        )}

        {/* ══ TAB 2 — TAGs ══ */}
        {activeTab === 2 && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CredentialPanel
                tipo="tag"
                tarjetas={tarjetas}
                setTarjetas={setTarjetas}
                accentColor="#1976d2"
                chipStyle={{ backgroundColor: "#e3f2fd", color: "#1976d2" }}
                borderColor="#e3f2fd"
                icon={<CreditCard />}
                label="Tarjetas TAG"
                chipLabel="NFC / RFID"
                placeholderCodigo="Código TAG"
                placeholderBulk="ABC1, DEF2, GHI3..."
                placeholderLabel="Etiqueta (ej: Tarjeta Principal)"
              />
            </Grid>
          </Grid>
        )}

        {/* ══ TAB 3 — QRs ══ */}
        {activeTab === 3 && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CredentialPanel
                tipo="qr"
                tarjetas={tarjetas}
                setTarjetas={setTarjetas}
                accentColor="#7b1fa2"
                chipStyle={{ backgroundColor: "#f3e5f5", color: "#7b1fa2" }}
                borderColor="#f3e5f5"
                icon={<CropFree />}
                label="Códigos QR"
                chipLabel="QR"
                placeholderCodigo="Código QR"
                placeholderBulk="QR1, QR2, QR3..."
                placeholderLabel="Etiqueta (ej: QR Acceso Garaje)"
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions style={dialogActionsStyle}>
        <Box flex={1} display="flex" alignItems="center">
          {activeTab === 0 &&
            (!formData.nombre.trim() || !formData.identificacion.trim()) && (
              <Typography variant="caption" color="error">
                * Complete los campos requeridos
              </Typography>
            )}
        </Box>
        <Button
          onClick={onClose}
          color="secondary"
          disabled={loading}
          style={{ textTransform: "none" }}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? (
              <CircularProgress size={16} style={{ color: "white" }} />
            ) : null
          }
          style={submitBtnStyle}
        >
          {getButtonText()}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default NewAndEditRostroDialog
